export enum SessionState {
  LoggedOut,
  LoggedIn,
  Expired,
  NeedsPasswordChange,
  PasswordExpired,
}
